



















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import machineryStatusRepository from '@/modules/machinery/services/machineryStatusRepository';

import Datagrid from '@/components/default/Datagrid.vue';

@Component({
  components: {
    Datagrid,
  },
})
export default class MachineryStatusTable extends Vue {
    private loading: boolean = true;
    private items: IMachineryStatus[] = [];

    private mounted() {
        this.loadData();
    }

    private async loadData() {
        try {
            this.loading = true;
            this.items = (await machineryStatusRepository.getAll()).data;
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.loading = false;
        }
    }

    private async insertRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await machineryStatusRepository.create(e.data);
                notificationService.saved();
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    private async updateRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                const command = Object.assign({}, e.oldData, e.newData);
                await machineryStatusRepository.update(command);
                notificationService.saved();
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    private async deleteRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await machineryStatusRepository.delete(e.data.id);
                notificationService.saved();
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    get columns() {
        const self = this;
        return [
            {
                dataField: 'name',
                caption: 'Naam',
                allowFiltering: false,
            },
            {
                dataField: 'active',
                caption: 'Actief',
                dataType: 'boolean',
            },
            {
                type: 'buttons',
                buttons: ['edit', 'delete'],
            },
        ];
    }

    get toolbarOptions() {
        return [
            {
                location: 'before',
                widget: 'dxButton',
                options: {
                icon: 'fas fa-plus',
                text: 'Toevoegen',
                stylingMode: 'outlined',
                type: 'success',
                onClick: () => {
                        ((this.$refs.grid as Datagrid)
                        .$refs.machineryStatusTable as any).instance.addRow();
                    },
                },
            },
        ];
    }
}
